import { _ } from "libs";
import React, { FC, memo, useContext, useEffect, useState } from "react";
import { Championship } from "../../types";
import { ChampionshipComparison, getChampionshipComparisons } from "../../actions";
import Loader from "../loader";
import ChampionshipContext from "../../contexts/championshipContext";

type ComparisonsProps = {
	onComparisonSelected?: any;
};

const Comparisons: FC<ComparisonsProps> = ({ onComparisonSelected }: ComparisonsProps) => {
	const { championship } = useContext(ChampionshipContext);

	const [comparisons, setComparisons] = useState([] as ChampionshipComparison[]);
	const [loading, setLoading] = useState(true);

	if (championship.settings?.trial?.hasExpiredTrial) {
		return null;
	}

	useEffect(() => {
		let unmounted = false;

		if (!unmounted) {
			if (championship && championship?.optedIn) {
				setLoading(true);
				loadComparisons().then(
					(res) => {
						setLoading(false);
					},
					(err) => {
						setLoading(false);
					}
				);
			}
		}

		return () => {
			unmounted = true;
		};
	}, [championship]);

	const loadComparisons = async () => {
		if (!championship) {
			return;
		}

		const comparisons = await getChampionshipComparisons(championship.uuid);
		setComparisons(comparisons);
	};

	if (championship && championship?.optedIn) {
		return (
			<div className="nBlock comparisons">
				<h5>{_("championship.comparisons.heading")}</h5>
				{!loading && comparisons?.length > 0 && (
					<div className="table">
						{comparisons.map((comparison, i) => {
							if (!championship.league?.id && comparison.type !== "watchlist") return null;
							return (
								<div
									className="cell capsule clickable"
									key={"championship.comparison." + i}
									onClick={() => onComparisonSelected(comparison.filterParameters, comparison.label)}
								>
									<div className="item comparison" data-type={comparison.type}>
										<div className="itemBody">
											<div className="value">
												<div className="icon" />
												{comparison.value && (
													<div className="position">
														{_("comparison.position", parseInt(comparison.value), {
															position: comparison.value,
														})}
													</div>
												)}
												{comparison.total && (
													<div className="total">
														{_("comparison.total", parseInt(comparison.total), {
															total: comparison.total,
														})}
													</div>
												)}
											</div>
											<div className="title">{comparison.label}</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				)}
				{loading && <Loader />}
			</div>
		);
	}
};

export default memo(Comparisons);
